<template>
  <div class="filter-status btnHover">
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        <i class="icon iconfont iconicon_task_grouping"></i>
        {{statusLabel.label}}
      </span>
      <el-dropdown-menu slot="dropdown" class="filter-status-dropdown">
        <div class="reset">
          <span class="title">任务状态</span>
        </div>
        <el-dropdown-item
        v-for="item in dataset"
        :key="item.value"
        :command="item.value"
        >
        <toolTip :title="item.label"><span>{{item.label}}</span></toolTip>
          <i class="icon iconfont iconicon_selected_more_task" v-show="status_filter === item.value"></i>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
  data() {
    return {
      dataset: [{
        label: '全部任务',
        value: ''
      }, {
        label: '未完成任务',
        value: 1
      }, {
        label: '已完成任务',
        value: 2
      }, {
        label: '未归档任务',
        value: 3
      }, {
        label: '已归档任务',
        value: 4
      }]
    }
  },
  computed: {
    ...mapState('task/task', {
      status_filter: state => state.queryMsg.status_filter
    }),
    statusLabel() {
      return this.dataset.find(res => res.value === this.status_filter) || {}
    }
  },
  methods: {
    ...mapMutations('task/task', ['set_status_filter']),
    handleCommand(val) {
      this.set_status_filter(val)
    }
  }
}
</script>
<style lang="scss">
.filter-status {
}
</style>
